// extracted by mini-css-extract-plugin
module.exports = {"icon":"_22O6q","text":"_8xaQt","button":"_3XtFB","textButton":"_2yM-i","iconButton":"_3Ly4_","animated":"_11HPf","verticalAlign":"_3VYrA"};